module.exports = __webpack_public_path__ + "img/program-closing_jmof.6e60a761.jpg";